export const getBannerClickedProps = () => {
    return {
        bannerName: 'banner_name',
        bannerAction: {
            key: 'banner_action',
            fn: () => 'click'
        },
        bannerId: 'banner_id',
        bannerType: 'banner_type',
        eventCategory: 'event_category'
    };
};
